var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toaster',{on:{"close-toaster":_vm.closeSummaryToaster},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('span',[_c('span',{staticClass:"bold"},[_vm._v("צפי ה"+_vm._s(_vm.incomeOrExpense))]),_vm._v(" נמחק מהתזרים")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }